<template>
  <fieldset class="radio-group">
    <slot />
  </fieldset>
</template>


<script>
export default {
  name: 'TRadioGroup',
  model: {
    prop: 'value',
    event: 'update:value',
  },
  reactiveProvide: {
    name: 'radioGroupContext',
    include: [
      'onChange',
      'value',
      'disabled',
      'name',
    ],
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    onChange(value) {
      this.$emit('update:value', value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
